var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogPost1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg4",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#434343",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#000000",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "url(#bg4)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 340,
    height: 240,
    rx: 8,
    fill: "#ffffff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 40,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#000"
  }, "Data Structures"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 70)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 300,
    height: 150,
    fill: "#2d2d2d",
    rx: 4
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 20,
    fontFamily: "monospace",
    fontSize: 12,
    fill: "#d4d4d4"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15,
    dy: "1.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#569cd6"
  }, "class"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#4ec9b0"
  }, "Node"), " { ... };"), /*#__PURE__*/React.createElement("tspan", {
    x: 15,
    dy: "1.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#569cd6"
  }, "class"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#4ec9b0"
  }, "LinkedList"), " { ... };"), /*#__PURE__*/React.createElement("tspan", {
    x: 15,
    dy: "1.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#c586c0"
  }, "void"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#9cdcfe"
  }, "main"), "() { ... }"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogPost1);
export default __webpack_public_path__ + "static/media/blog-post-1.15ad1325713c9921e94fb725698d570d.svg";
export { ForwardRef as ReactComponent };